<template>
    <div class="skills p-mt-0" data-cy="profile-view-skills">
        <div class="left">
            <span>
                <h5>{{t("please.choose.mainareasofexpertise")}}</h5>
                <Checklist v-model="aoeSelection"
                           :options="expertiseOptions"
                           optionLabel="name"
                           data-cy="wizard-expertise-option" />
                <small data-cy="wizard-expertise-option-error"
                       class="p-error"
                       v-for="(error, index) of v$.areasOfExpertise.$errors"
                       :key="index">
                    {{ error.$message }}
                </small>
            </span>
            <div data-cy="wizard-view-jobtitle-dropdown">
                <span class="p-no-float-label">
                    <ul data-cy="wizard-view-jobtitle-dropdown-value"
                        class="tags"
                        v-if="editableCandidate.jobTitles && editableCandidate.jobTitles.length > 0">
                        <li v-for="job in editableCandidate.jobTitles" :key="job.id">
                            {{ t(job.name) }}
                            <Button icon="pi pi-times"
                                    class="p-button-rounded p-button-outlined skills__remove"
                                    @click="handleJobTitleRemoval($event, job)"
                                    data-cy="wizard-jobtitle-selected" />
                        </li>
                    </ul>
                    <h5>{{t("please.choose.jobtitle")}}</h5>
                    <MultiSelect v-model="v$.jobTitles.$model"
                                 display="none"
                                 :filter="true"
                                 :autoFilterFocus="true"
                                 filterIcon="pi pi-search"
                                 :class="{ 'p-invalid': v$.jobTitles.$error }"
                                 :options="availableJobTitlesOptions"
                                 :optionLabel="t('name')"
                                 :showToggleAll="false"
                                 @change="onChange()"
                                 data-cy="wizard-choose-jobtitle" />
                    <label>{{t("current.job.title")}}</label>
                    <small data-cy="wizard-view-jobtitle-dropdown-error"
                           class="p-error p-mt-0"
                           v-for="(error, index) of v$.jobTitles.$errors"
                           :key="index">
                        {{ t(error.$message) }}
                    </small>
                </span>
            </div>


        </div>
        <div class="right">
            <div v-if="canSelectSkills">
                <div v-if="!containsLawyer">
                    <h5>
                        {{t("please.choose.competencesandskills")}}
                        <Tooltip :message="t('expertise.and.skill.tooltip.message2')" />
                    </h5>
                    <span class="p-no-float-label">
                        <ul data-cy="profile-view-competence-value"
                            class="tags"
                            v-if="editableCandidate?.skills && editableCandidate.skills.length > 0">
                            <li v-for="skill in editableCandidate.skills" :key="skill.name">
                                {{ skill.name }}
                                <Button icon="pi pi-times"
                                        class="p-button-rounded p-button-outlined skills__remove"
                                        @click="handleSkillRemoval($event, skill.id)"
                                        data-cy="wizard-competences-chosen" />
                            </li>
                        </ul>
                        <MultiSelect v-model="v$.skills.$model"
                                     :options="skillOptions"
                                     :filter="true"
                                     :autoFilterFocus="true"
                                     filterIcon="pi pi-search"
                                     display="none"
                                     :disabled="!canSelectSkills"
                                     :class="{ 'p-invalid': v$.skills.$error }"
                                     @change="determineSkillValidity"
                                     optionLabel="name"
                                     :showToggleAll="false"
                                     data-cy="wizard-competences-options" />
                        <label>{{t("add.competence")}}</label>
                        <small v-if="!canSelectSkills" class="p-error">
                            {{t("please.choose.subjectarea")}}
                        </small>
                        <small data-cy="wizard-competences-options-error"
                               class="p-error p-mt-0"
                               v-for="(error, index) of v$.skills.$errors"
                               :key="index">
                            {{ error.$message }}
                        </small>
                    </span>
                </div>

                <div v-else>
                    <h5>
                        {{t("please.choose.skills")}}
                        <Tooltip :message="t('expertise.and.skill.tooltip.message2')" />
                    </h5>
                    <span class="p-no-float-label">
                        <ul data-cy="profile-view-competence-value"
                            class="tags"
                            v-if="editableCandidate?.keySkills && editableCandidate.keySkills.length > 0">
                            <li v-for="skill in editableCandidate.keySkills" :key="skill.name">
                                {{ skill.name }}
                                <Button icon="pi pi-times"
                                        class="p-button-rounded p-button-outlined skills__remove"
                                        @click="handleKeySkillRemoval($event, skill.id)"
                                        data-cy="wizard-competences-chosen" />
                            </li>
                        </ul>
                        <MultiSelect v-model="v$.keySkills.$model"
                                     :options="keySkillOptions"
                                     :filter="true"
                                     :autoFilterFocus="true"
                                     filterIcon="pi pi-search"
                                     display="none"
                                     :disabled="!canSelectSkills"
                                     :class="{ 'p-invalid': v$.keySkills.$error }"
                                     @change="determineSkillValidity"
                                     optionLabel="name"
                                     :showToggleAll="false"
                                     data-cy="wizard-competences-options" />
                        <label>{{t("add.practicearea")}}</label>
                        <small v-if="!canSelectSkills" class="p-error">
                            {{t("please.choose.subjectarea")}}
                        </small>
                        <small data-cy="wizard-competences-options-error"
                               class="p-error p-mt-0"
                               v-for="(error, index) of v$.keySkills.$errors"
                               :key="index">
                            {{ error.$message }}
                        </small>
                    </span>

                    <h5>
                        {{t("please.choose.competencesandskills")}}
                        <Tooltip :message="t('expertise.and.skill.tooltip.message2')" />
                    </h5>
                    <span class="p-no-float-label">
                        <ul data-cy="profile-view-competence-value"
                            class="tags"
                            v-if="editableCandidate?.skills && editableCandidate.skills.length > 0">
                            <li v-for="skill in editableCandidate.skills.filter(x => !x.isKeySkill)" :key="skill.name">
                                {{ skill.name }}
                                <Button icon="pi pi-times"
                                        class="p-button-rounded p-button-outlined skills__remove"
                                        @click="handleSkillRemoval($event, skill.id)"
                                        data-cy="wizard-competences-chosen" />
                            </li>
                        </ul>
                        <MultiSelect v-model="v$.skills.$model"
                                     :options="notKeySkillOptions"
                                     :filter="true"
                                     :autoFilterFocus="true"
                                     filterIcon="pi pi-search"
                                     display="none"
                                     :disabled="!canSelectSkills"
                                     :class="{ 'p-invalid': v$.skills.$error }"
                                     @change="determineSkillValidity"
                                     optionLabel="name"
                                     :showToggleAll="false"
                                     data-cy="wizard-competences-options" />
                        <label>{{t("add.competence")}}</label>
                        <small v-if="!canSelectSkills" class="p-error">
                            {{t("please.choose.subjectarea")}}
                        </small>
                        <small data-cy="wizard-competences-options-error"
                               class="p-error p-mt-0"
                               v-for="(error, index) of v$.skills.$errors"
                               :key="index">
                            {{ error.$message }}
                        </small>
                    </span>
                </div>
            </div>
        </div>
        <div class="call-to-action mobile-bottom-nav" v-if="showButtons">
            <Button data-cy="button-profile-prev"
                    class="button-secondary button-back p-pl-3"
                    @click="prev()">
                <i class="pi pi-angle-left" />{{t("back")}}
            </Button>
            <Button data-cy="button-profile-next"
                    class="button-secondary button-next p-pr-3"
                    @click="next()">
                {{t("continue")}} <i class="pi pi-angle-right" />
            </Button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps, ref, defineEmits, computed } from "vue";
    import MultiSelect from "primevue/multiselect";
    import Checklist from "../CheckList.vue";
    import { CandidateProfile } from "@/models/CandidateProfile";
    import { Skill } from "@/models/Skill";
    import { AreaOfExpertise } from "@/models/AreaOfExpertise";
    import { JobTitle } from "@/models/JobTitle";
    import useVuelidate from "@vuelidate/core";
    import { helpers, requiredIf } from "@vuelidate/validators";
    import { useI18n } from "vue-i18n";

    const emit = defineEmits(["next", "previous", "skillValidityChanged", "keySkillValidityChanged"]);
    const props = defineProps<{
        candidate: CandidateProfile;
        availableSkills: Skill[];
        availableExpertises: AreaOfExpertise[];
        availableJobTitles: JobTitle[];
        showButtons: boolean;
    }>();

    const { t } = useI18n();

    function compare(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    const availableJobTitlesOptions = [...props.availableJobTitles];
    availableJobTitlesOptions.forEach(option => {
        option.name = t(option.name)
    });
    availableJobTitlesOptions.sort(compare)


    const editableCandidate = ref(props.candidate);

    const originalSkillIDs = editableCandidate.value.skills.map(
        (skill) => skill.id
    );

    const originalKeySkillIDs = editableCandidate.value.keySkills.map(
        (skill) => skill.id
    );

    const rules = {
        jobTitles: {},
        areasOfExpertise: {},
        skills: {},
        keySkills: {
            requiredIf: helpers.withMessage(t("validate.required.practicearea"), requiredIf(() => {
                return containsLawyer.value;
            }))
        },
    };

    const expertiseOptions = computed(() => {
        let result: AreaOfExpertise[];

        result = props.availableExpertises;
        result.forEach(option => {
            option.name = t(option.name)
        });

        return result;
    });

    const skillOptions = computed(() => {
        let result: Skill[];
        const aoes = editableCandidate.value.areasOfExpertise;
        const aoeIDs = aoes.map((aoe) => aoe.id);

        result = props.availableSkills.filter(
            (skill) =>
                !skill.areaOfExpertiseId || aoeIDs.indexOf(skill.areaOfExpertiseId) > -1
        );

        result.forEach(option => {
            option.name = t(option.name)
        });

        result.sort(compare);

        return result;
    });

    const aoeSelection = computed({
        get: () => {
            if (!editableCandidate.value) {
                return [] as AreaOfExpertise[];
            }
            let result: AreaOfExpertise[] = [];
            const aoeIDs = editableCandidate.value.areasOfExpertise.map(
                (aoe) => aoe.id
            );

            result = expertiseOptions.value.filter(
                (option) => aoeIDs.indexOf(option.id) > -1
            );
            return result;
        },
        set: (value) => {
            editableCandidate.value.areasOfExpertise = value;
            removeInvalidSkills();
        },
    });

    const keySkillOptions = ref(skillOptions.value.filter(x => x.isKeySkill));
    const notKeySkillOptions = ref(skillOptions.value.filter(x => !x.isKeySkill));
    const containsLawyer = ref(editableCandidate.value.jobTitles.find(e => e.id === 9 || e.id === 565) != null);
    const onChange = () => {
        keySkillOptions.value = props.availableSkills.filter(x => x.isKeySkill);
        notKeySkillOptions.value = props.availableSkills.filter(x => !x.isKeySkill);
        containsLawyer.value = editableCandidate.value.jobTitles.find(e => e.id === 9 || e.id === 565) != null;
        if (containsLawyer.value) {
            if (!editableCandidate.value.areasOfExpertise.find(x => x.id === props.availableExpertises[2].id))
                editableCandidate.value.areasOfExpertise.push(props.availableExpertises[2]);
        }
    }

    const removeInvalidSkills = () => {
        const aoeIDs = editableCandidate.value.areasOfExpertise.map((aoe) => aoe.id);
        editableCandidate.value.skills = editableCandidate.value.skills.filter(
            (skill) =>
                skill.areaOfExpertiseId && aoeIDs.indexOf(skill.areaOfExpertiseId) > -1
        );
        determineSkillValidity();
    };

    function determineSkillValidity() {
        const currentSkillIDs = editableCandidate.value.skills.map(
            (skill) => skill.id
        );
        const valid =
            originalSkillIDs.filter((origID) => currentSkillIDs.indexOf(origID) < 0)
                .length > 0;
        emit("skillValidityChanged", valid);
    }

    function determineKeySkillValidity() {
        const currentSkillIDs = editableCandidate.value.keySkills.map(
            (skill) => skill.id
        );
        const valid =
            originalKeySkillIDs.filter((origID) => currentSkillIDs.indexOf(origID) < 0)
                .length > 0;
        emit("keySkillValidityChanged", valid);
    }

    const canSelectSkills = computed(() => {
        return editableCandidate.value?.jobTitles?.length > 0;
    });

    const v$ = useVuelidate(rules, editableCandidate);

    function handleSkillRemoval(event, id: number) {
        editableCandidate.value.skills = editableCandidate.value.skills.filter(
            (skill) => skill.id != id
        );
        determineSkillValidity();
    }

    function handleKeySkillRemoval(event, id: number) {
        editableCandidate.value.keySkills = editableCandidate.value.keySkills.filter(
            (skill) => skill.id != id
        );
        determineKeySkillValidity();
    }

    const handleJobTitleRemoval = async (event, jobTitle: JobTitle) => {
        editableCandidate.value.jobTitles =
            editableCandidate?.value?.jobTitles.filter(
                (element) => element.id != jobTitle.id
            );
        onChange();
    };

    const validate = () => {
        v$.value.$touch();
        return v$.value.$error;
    };
    const next = () => {
        if (!validate()) {
            emit("next", editableCandidate.value);
        }
    };

    const prev = () => {
        emit("previous", editableCandidate.value);
    };
</script>

<style scoped lang="scss">
    h5 {
        margin-top: 20px;
    }

    .p-button.p-button-icon-only.skills__remove {
        width: 1.25rem;
        height: 1.25rem;
        padding: 0;
        border: none;
    }
</style>
